import React, { useEffect, useState } from "react";
import style from "./style.module.css";

export const DevBanner = () => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (
      process.env.NODE_ENV === "development" ||
      window.location.hostname.includes("dev")
    ) {
      const commitMeta = document.querySelector('meta[name="build-commit"]');
      const branchMeta = document.querySelector('meta[name="build-branch"]');

      if (commitMeta && branchMeta) {
        setInfo({
          commit: commitMeta.content,
          branch: branchMeta.content
        });
      }
    }
  }, []);

  if (!info) return null;

  return (
    <div className={style.banner}>
      <div className={style.bannerText}>
        Current Dev Branch: {info.branch} ({info.commit.slice(0, 7)})
      </div>
    </div>
  );
};
